module.exports = __webpack_public_path__ + "static/img/crystal-oscillator_256.c3b993a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/crystal-oscillator_256.png
// module id = fiaO
// module chunks = 0